import { Instance, SnapshotIn, types, getSnapshot } from 'mobx-state-tree';

import { BasePageQueryStore } from '@shared/stores/BasePageQuery.store';

export const NEOANALYTICS_FILTERS_KEY = 'neoanalytics_filters';

export const PageQueryStoreInferred = types.compose(BasePageQueryStore, types
    .model({
        entityIds:  types.array(types.string),
        entityVersions: types.array(types.string),
        actorIds: types.array(types.string),
        executionModes: types.array(types.string),
        platforms: types.array(types.string),
        endReasons: types.array(types.string),
        isCompleted: types.maybeNull(types.boolean),
        fullData: types.maybeNull(types.boolean),
        from: types.maybeNull(types.Date),
        to: types.maybeNull(types.Date),
    }))
    .volatile(() => ({
        _FILTER_KEY: NEOANALYTICS_FILTERS_KEY,
    }))
    .views(self => ({
        get getParams() {
            return getSnapshot(self);
        },
    }))
    .actions(self => ({
        setParams(params: IPageQueryStoreSnapshotIn) {
            self._setParams<IPageQueryStoreSnapshotIn>(params);
        },
    }))
    .actions(self => ({
        _prefillFromStorage() {
            if (self.getStorageParams) {
                self.setParams(self.getStorageParams);
            }
        },
    }))
    .actions(self => ({
        resetParams() {
            const FILTERS_TO_KEEP = {
                actorIds: self.getParams.actorIds,
                entityIds: self.getParams.entityIds,
                inGroup: self.getParams.inGroup,
                inGroupId: self.getParams.inGroupId,
                sortFieldName: self.getParams.sortFieldName,
                sortDirection: self.getParams.sortDirection,
            }
            self._resetParams(FILTERS_TO_KEEP);
        },
    }));

type PageQueryStoreFactoryType = typeof PageQueryStoreInferred;
interface IPageQueryStoreFactory extends PageQueryStoreFactoryType { }
export const PageQueryStore: IPageQueryStoreFactory = PageQueryStoreInferred;
export interface IPageQueryStore extends Instance<IPageQueryStoreFactory> { }
export interface IPageQueryStoreSnapshotIn extends SnapshotIn<IPageQueryStore> { }
